<template>
  <div class="deliver-goods">
    <div class="table-wrapper">
      <div class="header">
          <el-form ref="form" :model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="订单号">
                  <el-input v-model="form.subOrderNo" placeholder="可输入子单号查询"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 1">
                <el-form-item label="结算单号">
                  <el-input v-model="form.settleNo" placeholder="请输入结算单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 1">
                <el-form-item label="支付日期">
                  <el-date-picker
                    v-model="form.payedDate"
                    unlink-panels
                    :clearable="true"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="(value) => handleRangePickerChange(value, 'payedDate')"
                    size="small">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 2">
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="form.unpayedDate"
                    :clearable="true"
                    unlink-panels
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="(value) => handleRangePickerChange(value, 'unpayedDate')"
                    size="small">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button class="btn default-btn" style="margin-left: 10px" @click="exportData">导出</el-button>
                <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
                <el-button class="btn default-btn" @click="onReset">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
      </div>
      <tabs :tabList="subTabList" :activeTab="activeSubTab" :changeTab="changeTab"/>
<!--      已支付-->
      <div v-if="activeSubTab === 1">
        <!-- 表格-->
        <el-table
          :data="payedTableData"
          :max-height="300"
          style="width: 100%"
          @expand-change="expandChange"
        >
          <el-table-column
            type="expand"
            width="55"
          >
            <template slot-scope="props">
              <!--内嵌表格-->
              <el-table :data="props.row.child">
                <el-table-column
                  label="序号"
                  prop="serialNum"
                >
                </el-table-column>
                <el-table-column
                  label="主单号"
                  prop="mainOrder"
                >
                </el-table-column>
                <el-table-column
                  label="子单号"
                  prop="subOrder"
                >
                </el-table-column>
                <el-table-column
                  label="商品编码"
                  prop="skuCode"
                >
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="skuName"
                >
                </el-table-column>
                <el-table-column
                  label="采购数量"
                  prop="quantity"
                >
                </el-table-column>
                <el-table-column
                  label="采购单价"
                  prop="price"
                >
                </el-table-column>
                <el-table-column
                  label="采购总额"
                  prop="totalAmount"
                >
                </el-table-column>
              </el-table>
              <!-- 内嵌分页 -->
              <el-pagination
                @size-change="(val) => handleSizeChange(val,'detail', props.row)"
                @current-change="(val) => handleCurrentChange(val,'detail', props.row)"
                :current-page="props.row.detailPage"
                :page-sizes="[10, 50, 100, 200]"
                :page-size.sync="props.row.detailPagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="props.row.totalDetailCount"
              ></el-pagination>
            </template>
          </el-table-column>
          <el-table-column
            label="序号"
            width="120"
            prop="serialNum"
          >
          </el-table-column>
          <el-table-column
            prop="pushDate"
            label="结算单推送日期"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="confirmDate"
            label="确认日期"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="corpName"
            label="采购公司"
          >
          </el-table-column>
          <el-table-column
            prop="settleNo"
            label="结算单号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="结算单生成日期"
            width="120">
          </el-table-column>
          <el-table-column
            prop="totalCount"
            label="采购总量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="采购总金额"
            width="120">
          </el-table-column>
          <el-table-column
            prop="payStatus"
            label="支付状态"
            width="120">
          </el-table-column>
          <el-table-column
            prop="payTime"
            label="支付日期"
            width="120">
          </el-table-column>
        </el-table>
      </div>
<!--      未支付-->
      <div v-if="activeSubTab === 2">
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="1">
<!--            待处理订单-->
            未支付1
          </el-checkbox>
          <!-- 表格-->
          <el-table
            :data="billTableData"
            :max-height="300"
            style="width: 100%"
          >
            <el-table-column
              label="序号"
              width="120"
              prop="serialNum"
            >
            </el-table-column>
            <el-table-column
              prop="orderPushDate"
              label="订单推送日期"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="mainOrder"
              label="主单号"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="subOrder"
              label="子单号"
            >
            </el-table-column>
            <el-table-column
              prop="skuCode"
              label="商品编码"
              width="120">
            </el-table-column>
            <el-table-column
              prop="skuName"
              label="商品名称"
              width="120">
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="采购数量"
              width="120">
            </el-table-column>
            <el-table-column
              prop="price"
              label="采购单价"
              width="120">
            </el-table-column>
            <el-table-column
              prop="totalAmount"
              label="采购总金额"
              width="120">
            </el-table-column>
            <el-table-column
              prop="deliveryDate"
              label="出库日期"
              width="120">
            </el-table-column>
            <el-table-column
              prop="orderStatus"
              label="订单状态"
              width="120">
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="(val) => handleSizeChange(val,'bill')"
            @current-change="(val) => handleCurrentChange( val,'bill')"
            :current-page="billPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="billPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalBillCount"
          >
          </el-pagination>
          <el-checkbox label="2">
<!--            待结算金额-->
            未支付2
          </el-checkbox>
          <!-- 表格-->
          <el-table
            :data="unsettledTableData"
            :max-height="300"
            style="width: 100%"
          >
            <el-table-column
              label="序号"
              width="120"
              prop="serialNum"
            >
            </el-table-column>
            <el-table-column
              prop="orderPushDate"
              label="订单推送日期"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="mainOrder"
              label="主单号"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="subOrder"
              label="子单号"
            >
            </el-table-column>
            <el-table-column
              prop="skuCode"
              label="商品编码"
              width="120">
            </el-table-column>
            <el-table-column
              prop="skuName"
              label="商品名称"
              width="120">
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="采购数量"
              width="120">
            </el-table-column>
            <el-table-column
              prop="price"
              label="采购单价"
              width="120">
            </el-table-column>
            <el-table-column
              prop="totalAmount"
              label="采购总金额"
              width="120">
            </el-table-column>
            <el-table-column
              prop="deliveryDate"
              label="出库日期"
              width="120">
            </el-table-column>
            <el-table-column
              prop="orderStatus"
              label="订单状态"
              width="120">
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="(val) => handleSizeChange(val, 'unsettled')"
            @current-change="(val) => handleCurrentChange( val,'unsettled')"
            :current-page="unsettledPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="unsettledPagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalUnsettledCount"
          >
          </el-pagination>
        </el-checkbox-group>
      </div>
      <div v-if="activeSubTab === 1">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/tabs/tabs";
import {
  queryBillOrder,
  queryPayedSettle,
  queryPayedSettleDetail,
  queryUnsettledOrder
} from "../../../../models/r4ReportModel";
import r4ReportApiList from "../../../../service/basic/r4ReportApiList";
import moment from "moment";
import {buildURL} from "../../../../utils/utils";
export default {
  components: {
    Tabs
  },
   data() {
     return {
       form: {
         payedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         subOrderNo: '',
         settleNo: '',
         unpayedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
       },
       pageSize: 10,
       page: 1,
       detailPagesize: 10,
       detailPage: 1,
       pickerOptions: {
         disabledDate (current) {
           return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months'))
         }
       },
       payedTableData: [ // todo:
         {
           "confirmDate": "",
           "corpName": "",
           "payStatus": 0,
           "payTime": "",
           "pushDate": "",
           "settleNo": "",
           "totalAmount": 0,
           "totalCount": 0
         }
       ],
       payedDetailTableData: [],
       loading: false,
       activeSubTab: 1,
       subTabList: [
         {
           id: 1,
           name: '已支付'
         },
         {
           id: 2,
           name: '未支付'
         }
       ],
       totalCount:0,
       totalDetailCount: 0,
       singleSettleNo: '',
       checkList: [],
       billPage: 1,
       billPageSize: 10,
       totalBillCount: 0,
       billTableData: [],
       unsettledTableData: [],
       unsettledPage: 1,
       unsettledPagesize: 10,
       totalUnsettledCount: 0,
     }
   },
    created () {
      this.loadPayedSettle();
    },
   methods: {
     // 获取已支付结算单
     loadPayedSettle() {
       this.activeSubTab = 1;
       queryPayedSettle({
         supplierId: localStorage.getItem('supplier_id'),
         page: this.page - 1,
         pageSize: this.pageSize,
         settleNo: this.form.settleNo,
         subOrderNo: this.form.subOrderNo,
         startDate: this.form.payedDate ? this.form.payedDate[0] + ' 00:00:00' : '',
         endDate: this.form.payedDate ? this.form.payedDate[1] + ' 23:59:59' : ''
       }).then(res => {
         this.payedTableData = res ? res.content.map((item, index) => {
           item.serialNum = index + 1 + (this.page - 1) * this.pageSize;
           item.child = [] // 先给一个空值
           item.expand = false  // 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
           item.detailPage = 1;
           item.detailPagesize = 10;
           item.totalDetailCount = 0;
           return item;
         }) : []
         this.totalCount = res ? Number(res.totalElements) : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
     // 切换tab
     changeTab(type) {
       this.activeSubTab = type;
       this.page = 1;
       this.pageSize=10;
       this.checkList = [];
       this.form = {
         payedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         subOrderNo: '',
         settleNo: '',
         unpayedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
       }
       if (type === 1) {
          this.loadPayedSettle();
       } else {
          this.loadOrder();
          this.loadUnsettledOrder();
       }
     },
     // 重置
     onReset() {
       this.page = 1;
       this.pageSize=10;
       this.billPage = 1;
       this.billPageSize=10;
       this.unsettledPage = 1;
       this.unsettledPagesize = 10;
       this.form = {
         payedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         subOrderNo: '',
         settleNo: '',
         unpayedDate: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
       }
       if (this.activeSubTab === 1) {
         this.loadPayedSettle();
       } else {
         this.loadOrder();
         this.loadUnsettledOrder();
       }
     },
     handleRangePickerChange(value, type) {
       console.log(value, "value", moment(value[1]).subtract(3, "months").isBefore(moment(value[0])));
       if (!moment(value[1]).subtract(3, "months").isBefore(moment(value[0]))) {
         this.$message.error("选择的时间跨度最大为3个月");
         if (type === "payedDate") {
           this.form.payedDate = [moment(value[1]).subtract(3, "months").format('YYYY-MM-DD'), moment(value[1]).format('YYYY-MM-DD')];
         } else {
           this.form.unpayedDate = [moment(value[1]).subtract(3, "months").format('YYYY-MM-DD'), moment(value[1]).format('YYYY-MM-DD')];
         }
       } else {
         if (type === "payedDate") {
           this.form.payedDate = value;
         } else {
           this.form.unpayedDate = value;
         }
       }
     },
     //搜索
     onSubmit() {
        if (this.activeSubTab === 1) { // 已支付
          this.loadPayedSettle();
        } else {
          this.loadOrder();
          this.loadUnsettledOrder();
        }
     },
     // 分页
     handleSizeChange (val, type, row) {
       console.log(val, type);
       switch(type) {
         case 'detail':
           row.detailPageSize = val;
           row.expand = true;
           this.loadDetail(row);
           break;
         case 'bill':
           this.billPageSize = val;
           this.loadOrder();
           break;
         case 'unsettled':
           this.unsettledPagesize = val;
           this.loadUnsettledOrder();
           break;
         default:
           this.pagesize = val
           this.loadPayedSettle()
           break;
       }
     },
     // 分页
     handleCurrentChange (val, type, row) {
       switch(type) {
         case 'detail':
           row.detailPage = val;
           row.expand = true;
           this.loadDetail(row);
           break;
         case 'bill':
           this.billPage = val;
           this.loadOrder();
           break;
         case 'unsettled':
           this.unsettledPage = val;
           this.loadUnsettledOrder();
           break;
         default:
           this.page = val
           this.loadPayedSettle()
           break;
       }
     },
     //展开
     expandChange (row, expandedRows) {
       console.log(row, expandedRows);
       if (!row.expand) {  // 先判断该行是否已经展开了
         this.loadDetail(row);
       } else {
         row.expand = false;
       }
     },
     // 获取已支付结算单明细
     loadDetail(row) {
       this.singleSettleNo = row.settleNo;
       queryPayedSettleDetail({
         settleNo: row.settleNo,
         page: row.detailPage - 1,
         pageSize: row.detailPagesize
       }).then(res => {
         row.expand = true // 设置展开行是打开的
         row.child = res ? res.content.map((item, index) => {
           item.serialNum = index + 1 + (row.detailPage - 1) * row.detailPagesize;
           return item;
         }) : [];
         row.totalDetailCount = res ? Number(res.totalElements) : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
     // 待处理订单
     loadOrder() {
       queryBillOrder({
         supplierId: localStorage.getItem('supplier_id'),
         page: this.billPage - 1,
         pageSize: this.billPageSize,
         settleNo: this.form.settleNo,
         subOrderNo: this.form.subOrderNo,
         startDate: this.form.unpayedDate ? this.form.unpayedDate[0] + ' 00:00:00' : '',
         endDate: this.form.unpayedDate ? this.form.unpayedDate[1] + ' 23:59:59' : ''
       }).then(res => {
         this.billTableData = res ? res.content.map((item, index) => {
           item.serialNum = index + 1 + (this.billPage - 1) * this.billPageSize;
           return item;
         }) : []
         this.totalBillCount = res ? Number(res.totalElements) : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
     // 待处理订单
     loadUnsettledOrder() {
       queryUnsettledOrder({
         supplierId: localStorage.getItem('supplier_id'),
         page: this.unsettledPage - 1,
         pageSize: this.unsettledPagesize,
         settleNo: this.form.settleNo,
         subOrderNo: this.form.subOrderNo,
         startDate: this.form.unpayedDate ? this.form.unpayedDate[0] + ' 00:00:00' : '',
         endDate: this.form.unpayedDate ? this.form.unpayedDate[1] + ' 23:59:59' : ''
       }).then(res => {
         this.unsettledTableData = res ? res.content.map((item, index) => {
           item.serialNum = index + 1 + (this.unsettledPage - 1) * this.unsettledPagesize;
           return item;
         }) : []
         this.totalUnsettledCount = res ? Number(res.totalElements) : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
     // 导出
     exportData() {
      if (this.activeSubTab === 1) { // 已支付
        const params = {
          subOrderNo: this.form.subOrderNo,
          settleNo: this.form.settleNo,
          startDate: this.form.payedDate ? this.form.payedDate[0] + ' 00:00:00' : '',
          endDate:this.form.payedDate ? this.form.payedDate[1] + ' 23:59:59' : '',
          supplierId: localStorage.getItem('supplier_id'),
        }
        console.log(`${myhostname}${r4ReportApiList.exportPayedSettleDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
        window.open(`${myhostname}${r4ReportApiList.exportPayedSettleDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
      } else {// 未支付
        console.log(this.checkList, "checkList"); // todo
        if (this.checkList && this.checkList.length === 0) {
          this.$message.error("请勾选导出的单据");
          return;
        }
        const params = {
          subOrderNo: this.form.subOrderNo,
          startDate: this.form.unpayedDate ? this.form.unpayedDate[0] + ' 00:00:00' : '',
          endDate:this.form.unpayedDate ? this.form.unpayedDate[1] + ' 23:59:59' : '',
          flag:  this.checkList && this.checkList.length === 2 ? 0 : this.checkList[0],// 0:全部,1:待处理,2:待结算
          supplierId: localStorage.getItem('supplier_id'),
        }
        console.log(`${myhostname}${r4ReportApiList.exportUnPayedSettleDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
        window.open(`${myhostname}${r4ReportApiList.exportUnPayedSettleDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
      }
     }
   }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  width: 100%;
  padding: 10px;
  background: #fff;
  .el-input__inner {
    width: 100% !important;
  }
  .el-icon-date:before {
    top:0;
  }
  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }
  .deliver-goods {
    position: relative;
    top:40px;
  }
  .default-btn {
    background: #FFF;
    border: 1px solid #DCDFE6;
  }
  .el-checkbox-group {
    margin-top: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/summaryReport/components/settleList.vue